//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { stringToNumber } from "@/utils";
import { InsurMutations } from "./store";
import Inform from "@/views/stencil/components/inform.vue";
import BaseInfo from "./components/index/baseInfo";
import Monthly from "./components/monthly";
import Mechanism from "./components/mechanism";
import Details from "./components/index/details";
import UseInfo from "@/views/stencil/components/useInfo";
import Basefoot from "./components/common/Basefoot";
import Question from "./components/index/Question.vue";
import { Share } from "@/utils/commonUtils";
import { insurancePage, insurancePreCheck } from "@/model/javaApi/detail.js";
import clearKeepAlive from "@/utils/mixin/mixinCache";
import mixinTxrNewWeb, { privateKeyMap } from "@/utils/mixin/mixinTxrNewWeb";
import Moment from "moment";
import { setSessionParme } from "@/utils/commonUtils";
import { priceFormatter } from "./components/_utils";
import { get } from "lodash";

export default {
  name: "stencilDetial",
  mixins: [clearKeepAlive, mixinTxrNewWeb],

  data() {
    return {
      inform: false,
      load: false,
      res: {},
    };
  },
  components: {
    Inform,
    BaseInfo,
    Monthly,
    Mechanism,
    Details,
    UseInfo,
    Basefoot,
    Question,
  },
  computed: {
    channelCommodityCode() {
      return this.$route.query.channelCommodityCode;
    },
    showScheme() {
      const schemeServiceList = get(this.res, "schemeServiceList");
      if (!Array.isArray(schemeServiceList) || schemeServiceList.length === 0)
        return null;
      const allSalePriceIsZero = schemeServiceList.filter(
        (item) => item.salePrice === 0 || item.salePrice === "0"
      );
      let current = null;
      /**
       * allSalePriceIsZero.length > 0 -> 有划线价格（开启赠送）
       */
      (allSalePriceIsZero.length > 0
        ? allSalePriceIsZero
        : schemeServiceList
      ).forEach((scheme) => {
        const price = stringToNumber(get(scheme, "price"));
        if (price == null) return;
        if (!current) {
          current = scheme;
        } else {
          const currentPrice = stringToNumber(get(current, "price"));
          if (currentPrice != null && price < currentPrice) {
            current = scheme;
          }
        }
      });
      return current;
    },
    commodityPrice() {
      const showScheme = this.showScheme;
      if (showScheme === null) return "未配置方案";
      const salePrice = get(showScheme, "salePrice");
      if (salePrice != null) {
        return priceFormatter(salePrice);
      }
      const price = get(showScheme, "price");
      if (price != null) {
        return priceFormatter(price);
      }
      return "未获取到售价";
    },
    isMultiplePrice() {
      const schemeServiceList = get(this.res, "schemeServiceList");
      return Array.isArray(schemeServiceList) && schemeServiceList.length > 1;
    },
    markingPrice() {
      const showScheme = this.showScheme;
      if (showScheme === null) return null;
      const price = get(showScheme, "price");
      const salePrice = get(showScheme, "salePrice");
      if (price != null && salePrice != null) return priceFormatter(price);
      return get(this.res, "originalPrice");
    },
    /**
     * 账户类型
     * 0-注册金保信+新氧，1-注册金保信
     */
    accountRule() {
      return get(this.res, "accountRule", undefined);
    },
  },
  activated() {
    document.title = this.res.topTitle || "";
  },
  watch: {
    load(newVal, oldVal) {
      if (newVal) {
        if (this.res) {
          let obj = {
            shareContent: this.res.shareContent,
            shareTimelineContent: this.res.shareContent,
            shareImgurl: this.res.shareImageUrl,
            shareTitle: this.res.shareFriend,
            shareUrl: `${window.location.href}`,
            rightBtnStatus: 1,
          };
          let objCircle = {
            shareContent: this.res.shareTimeline,
            shareTimelineContent: this.res.shareTimeline,
            shareImgurl: this.res.shareImageUrl,
            shareTitle: this.res.shareTimeline,
            shareUrl: `${window.location.href}`,
            rightBtnStatus: 1,
          };
          Share(obj, "sybao_ins_product_share_result_sys", objCircle);
        }
      }
    },
    inform(newVal, oldVal) {
      if (newVal) {
        this.STATISTICS_CONFIG.insur_firstinfo_page();
      }
    },
  },
  created() {
    this.getInfo();
  },
  mounted() {
    // this.$nextTick(() => {
    // 	// 回溯视频
    // 	this.postTX(this.channelCommodityCode);
    // });
  },
  methods: {
    goCertifications() {
      window.location.href = `https://sybao.soyoung.com/api/index?sybao=boy&url=${encodeURIComponent('https://h5.chinaceib.com/skypegmwcn/#/information_exposure/certifications')}`;
    },

    getInfo() {
      /** 跳转缺省页 */
      insurancePage({
        channelCommodityCode: this.channelCommodityCode,
        ignoreError: true,
      })
        .then((res) => {
          // res.beginTime = Moment()
          // 	.subtract(2, "days")
          // 	.format("YYYY-MM-DD HH:mm:ss");
          // res.endTime = Moment()
          // 	.add(5, "years")
          // 	.format("YYYY-MM-DD HH:mm:ss");
          // 和后端确认
          setSessionParme({
            pid: this.$route.query.channelCommodityCode,
            ch: get(res, "channelName"),
          });
          // res.remindCount = "999999988";
          // res.remindTime = Moment()
          // 	.subtract(1, "days")
          // 	.format("YYYY-MM-DD HH:mm:ss");
          // res.accountRule = 1;
          InsurMutations.insurance(res);
          document.title = res.topTitle;
          this.res = res;
          this.$nextTick(() => {
            // 回溯视频
            this.postTX(
              privateKeyMap[res.productCode]
                ? res.productCode
                : this.channelCommodityCode
            );
          });
          this.load = true;
        })
        .catch((res) => {
          if (res.code == 406) {
            this.$router.replace("/insuranceDraw");
          }
          // ignore res request已经添加全局响应处理
        })
        .finally(() => {
          this.STATISTICS_CONFIG.insur_proinfo_page();
        });
    },
    btnClick() {
      this.STATISTICS_CONFIG.insur_proinfo_submit2_click();
      insurancePreCheck(this.$route.query.channelCommodityCode)
        .then(() => {
          this.inform = true;
        })
        .catch((error) => { });
      return;
      // TODO: 所有判断完全依赖新增接口，前端不做处理
      // 不满足后台设置的购买数量的限制   商品限制每人可购买x份 -- 目前后台没有返回
      if (!this.res.isActive) {
        //(1.已上架 0.已下架)
        this.$toast("抱歉，商品已经下架");
      } else if (this.diff(this.res.beginTime) < 0) {
        this.$toast(
          "商品将于" +
          Moment(this.res.beginTime).format("YYYY-MM-DD") +
          "开始销售"
        );
      } else if (this.diff(this.res.endTime) > 0) {
        this.$toast("抱歉，活动已经结束");
      } else if (this.res.stock && this.res.stock - 1 < 0) {
        this.$toast("抱歉，暂无库存");
      } else {
        this.inform = true;
      }
    },
    custUrlClick() {
      this.STATISTICS_CONFIG.insur_proinfo_contactonline_click();
    },
    // 对比时间
    diff(t) {
      const time = Moment(t).format("YYYY-MM-DD HH:mm:ss");
      const mydate = Moment(Moment(new Date()).format("YYYY-MM-DD HH:mm:ss"));
      return mydate.diff(time);
    },
    // 投保流程点击我知道了
    next() {
      this.inform = false;
      this.$router.push({
        path: "/detailInfo",
        query: {
          ...this.$route.query,
          channelCommodityName: this.res.commodityName,
          productCode: this.res.productCode,
          schemeCode: this.showScheme ? this.showScheme.schemeCode : undefined,
        },
        flag: "postdisable",
      });
    },
  },
};
